import React from 'react';
import {Container} from '~/common/fabric/CreateDesign/components/Container/Container';
import {Background} from '~/common/fabric/CreateDesign/components/Background/Background';
import {BackgroundEditor} from '~/common/fabric/CreateDesign/components/Background/BackgroundEditor';

export const BackgroundContainer = () => (
  <Container>
    <Background />
    <BackgroundEditor />
  </Container>
);
